class CustomTestimonialsCarousel extends HTMLElement {
    constructor() {
        super();
        this.slidesPerPage =
            (Number(this.getAttribute("data-testimonials-amount")) || 3) + 1;
        this.autoScrollDelay =
            Number(this.getAttribute("data-auto-scroll-delay")) || false;
        this.items = this.querySelectorAll("custom-testimonials-carousel-item");
        this.itemsContainer = this.querySelector(
            ".custom-testimonials-carousel-items"
        );
        this.prevBtn = this.querySelector(
            ".custom-testimonials-carousel-btn-back"
        );
        this.nextBtn = this.querySelector(
            ".custom-testimonials-carousel-btn-next"
        );

        this.prevBtn.addEventListener("click", this.handle_prev_btn);
        this.nextBtn.addEventListener("click", this.handle_next_btn);
        this.itemsContainer.addEventListener(
            "transitionend",
            this.handle_slider_transition
        );
        window.addEventListener("resize", this.handle_window_change);
        this.handle_window_change();
        this.handle_set_clonned();
        this.itemsContainer.style.display = "flex";
        this.direction = -1;
        this.delayInterval = false;
        this.handle_auto_scroll_init();
        this.timeOut = null;
    }

    handle_prev_btn = () => {
        this.direction = 1;
        this.delayInterval = true;
        if (this.timeOut !== null) clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
            this.delayInterval = false;
        }, (this.autoScrollDelay || 5000) + 5000);
        this.handle_slider_move();
    };

    handle_next_btn = () => {
        this.direction = -1;
        this.delayInterval = true;
        if (this.timeOut !== null) clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
            this.delayInterval = false;
        }, 10000);
        this.handle_slider_move();
    };

    handle_slider_move = () => {
        const itemsAmount = this.querySelectorAll(
            "custom-testimonials-carousel-item"
        ).length;
        this.itemsContainer.style.transform = `translate(-${
            this.itemsWidth *
            ((itemsAmount + (this.slidesPerPage % 2 === 0 ? 0 : 1)) / 2 -
                (1 + this.direction))
        }px)`;
    };

    handle_slider_transition = () => {
        if (this.direction === -1) {
            this.itemsContainer.appendChild(
                this.itemsContainer.firstElementChild
            );
        } else {
            this.itemsContainer.prepend(this.itemsContainer.lastElementChild);
        }
        const items = [
            ...this.querySelectorAll("custom-testimonials-carousel-item"),
        ];
        const itemsAmount = items.length;
        this.itemsContainer.style.transition = "none";
        const positionInPx =
            this.itemsWidth *
            ((itemsAmount + (this.slidesPerPage % 2 === 0 ? 0 : 1)) / 2 - 1);
        this.itemsContainer.style.transform = `translate(-${positionInPx}px)`;
        const position =
            positionInPx / this.itemsWidth + this.slidesPerPage / 2 - 0.5;
        setTimeout(() => {
            this.itemsContainer.style.transition = "all 0.5s";
        });
        const targetItem = items.at(position);
        targetItem.classList.add("custom-testimonials-carousel-item-active");
        items.forEach((item) => {
            if (item !== targetItem) {
                item.classList.remove(
                    "custom-testimonials-carousel-item-active"
                );
            }
        });
    };

    handle_window_change = () => {
        let newValue = 0;
        if (document.body.offsetWidth === this.offsetWidth) {
            newValue =
                (Number(this.getAttribute("data-testimonials-amount")) || 3) +
                1;
        } else {
            newValue =
                Number(this.getAttribute("data-testimonials-amount")) || 3;
        }
        if (document.body.offsetWidth <= 756) {
            newValue = 1;
        } else if (document.body.offsetWidth <= 1000) {
            newValue = 4;
        }
        this.slidesPerPage = newValue;
        this.itemsWidth = this.offsetWidth / newValue;
        this.querySelectorAll("custom-testimonials-carousel-item").forEach(
            (item) => {
                item.style.width = `${this.itemsWidth}px`;
            }
        );
        this.handle_change_on_screen_rezise();
    };

    handle_set_clonned = () => {
        const items = [...this.items];
        const get_cloned_items = (items) =>
            [...items].map((item) => item.cloneNode(true));
        const totalItems = this.slidesPerPage;
        const finalItems = [];
        if (totalItems * 2 - items.length > 0) {
            const missingItemsAmount = totalItems * 2 - items.length;
            for (let i = 0; i < missingItemsAmount; i++) {
                finalItems.push(...get_cloned_items(items));
            }
        } else {
            finalItems.push(...items);
        }

        const itemsCount = items.length;
        if (itemsCount.length % 2 === 0) {
            const value = itemsCount.length / 2;
            finalItems.unshift(...get_cloned_items(items).slice(0, value));
            finalItems.push(
                ...get_cloned_items(items).slice(
                    items.length - 1 - value,
                    items.length - 1
                )
            );
        } else {
            let value = (itemsCount.length - 1) / 2;
            finalItems.unshift(...get_cloned_items(items).slice(0, value + 1));
            finalItems.push(
                ...get_cloned_items(items).slice(
                    items.length - 1 - value,
                    items.length - 1
                )
            );
        }
        const itemsAmount = finalItems.length;
        const positionInPx =
            this.itemsWidth *
            ((itemsAmount + (this.slidesPerPage % 2 === 0 ? 0 : 1)) / 2 - 1);
        const position =
            positionInPx / this.itemsWidth + this.slidesPerPage / 2 - 0.5;
        const targetItem = finalItems.at(position);
        targetItem.classList.add("custom-testimonials-carousel-item-active");
        finalItems.forEach((item) => {
            item.style.width = `${this.itemsWidth}px`;
        });
        this.itemsContainer.innerHTML = "";
        this.itemsContainer.append(...finalItems);
        this.itemsContainer.style.transition = "none";
        this.itemsContainer.style.transform = `translate(-${positionInPx}px)`;
        setTimeout(() => {
            this.itemsContainer.style.transition = "all 0.5s";
        });
    };

    handle_change_on_screen_rezise = () => {
        const items = [...this.items];
        const currentItemsCount = this.querySelectorAll(
            "custom-testimonials-carousel-item"
        ).length;
        const get_cloned_items = (items) =>
            [...items].map((item) => item.cloneNode(true));
        const totalItems = this.slidesPerPage;
        const finalItems = [];
        if (totalItems * 3 - currentItemsCount > 0) {
            const missingItemsAmount = totalItems * 2 - currentItemsCount;
            for (let i = 0; i < missingItemsAmount; i++) {
                finalItems.push(...get_cloned_items(items));
            }
            const itemsCount = items.length;
            if (itemsCount.length % 2 === 0) {
                const value = itemsCount.length / 2;
                finalItems.unshift(...get_cloned_items(items).slice(0, value));
                finalItems.push(
                    ...get_cloned_items(items).slice(
                        items.length - 1 - value,
                        items.length - 1
                    )
                );
            } else {
                let value = (itemsCount.length - 1) / 2;
                finalItems.unshift(
                    ...get_cloned_items(items).slice(0, value + 1)
                );
                finalItems.push(
                    ...get_cloned_items(items).slice(
                        items.length - 1 - value,
                        items.length - 1
                    )
                );
            }
            const itemsAmount = finalItems.length;
            const positionInPx = this.itemsWidth * (itemsAmount / 2 - 1);
            const position =
                positionInPx / this.itemsWidth + this.slidesPerPage / 2 - 0.5;
            const targetItem = finalItems.at(position);
            targetItem.classList.add(
                "custom-testimonials-carousel-item-active"
            );
            finalItems.forEach((item) => {
                item.style.width = `${this.itemsWidth}px`;
            });
            this.itemsContainer.innerHTML = "";
            this.itemsContainer.append(...finalItems);
            this.itemsContainer.style.transition = "none";
            this.itemsContainer.style.transform = `translate(-${positionInPx}px)`;
            setTimeout(() => {
                this.itemsContainer.style.transition = "all 0.5s";
            });
        }
    };

    handle_auto_scroll_init = () => {
        const interval_function = () => {
            if (this.delayInterval === true) {
                return;
            }
            this.direction = -1;
            this.handle_slider_move();
        };
        if (this.autoScrollDelay !== false)
            this.innerInterval = setInterval(
                interval_function,
                this.autoScrollDelay
            );
    };
}

if (!customElements.get("custom-testimonials-carousel")) {
    customElements.define(
        "custom-testimonials-carousel",
        CustomTestimonialsCarousel
    );
}
